import { useTranslation } from 'gatsby-plugin-react-i18next';

import { FlyInText, OpacityWrapper } from '../Atoms/Animations';
import ArrowButton from '../Atoms/ArrowButton';
import Link from '../Atoms/Link';


const categoriesData = [
  {
    title: 'categories.0.title',
    description: 'categories.0.description',
    url: '?category=buyingGuide',
  },
  {
    title: 'categories.1.title',
    description: 'categories.1.description',
    url: '?category=editorial',
  },
  {
    title: 'categories.2.title',
    description: 'categories.2.description',
    url: '?category=watchesAndTechnic',
  },
  {
    title: 'categories.3.title',
    description: 'categories.3.description',
    url: '?category=investments',
  },
]

const MagazineCategories = () => {
  const { t } = useTranslation();


  return (
    <section className="py-12 px-4 lg:px-8">
      <div className="max-w-screen-2xl w-full mx-auto">
        <h2 className="font-light font-cirka text-center pb-16 text-xl">{t('categories.heading')}</h2>
        <dl
          className="lg:grid lg:grid-cols-4 lg:gap-5 flex overflow-x-scroll lg:overflow-x-hidden"
          style={{ WebkitOverflowScrolling: 'touch', scrollSnapType: 'x mandatory', scrollBehavior: 'smooth' }}
          >
          {categoriesData.map((category, index) => (
            <OpacityWrapper
              className="bg-blue h-85 lg:h-112 w-60 lg:w-auto lg:p-10 p-6 mr-6 lg:mr-0 flex flex-col justify-between flex-shrink-0 overflow-y-hidden"
              style={{ scrollSnapAlign: 'start' }}
              key={`MagazineCategories-${index}`}
              >
              <div className="text-primary font-roboto">
                <FlyInText tag="h3" className="font-cirka text-xl xl:text-4xl">{t(category.title)}</FlyInText>
              </div>
              <div>
                <FlyInText tag="dd" y="80px" className="mb-8 text-white font-roboto font-light text-sm lg:text-base">{t(category.description)}</FlyInText>
                <Link to={category.url}>
                  <ArrowButton className="ml-2" />
                </Link>
              </div>
            </OpacityWrapper>
          ))
          }
        </dl>
      </div>
    </section>
  );
}

export default MagazineCategories;
